import { useState, useEffect } from "react";
import { Col, Flex, Row, Grid } from "antd";
import { MyButton, MyText, MyCard } from "../../../common";
import { WaveContainer } from "../WaveContainer";
import { HeartFilled, HeartOutlined } from "@ant-design/icons";
import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTE_PATH } from "../../../../utils/constants/routes";
import { fetchArticleList } from "../../../../api";
import {EmblaOptionsType} from "embla-carousel";
import EmblaCarousel from "./Carousel";
import {useTranslation} from "react-i18next";
import { useLang } from '../../../../utils/context/lang';
import { useEmbeddedNavigate } from "../../../../utils/context/embed";
import { useDispatch, useSelector } from "react-redux";
import { fetchArticleListAction } from "../../../../utils";

const isMobile = window.innerWidth < 768;
const OPTIONS: EmblaOptionsType = { dragFree: true, loop: true }

const Component = memo(({ item, onClick }) => {

  return (
    <MyCard
      hoverable
      onClick={onClick}
      style={{height: '100%'}}
      cover={
        <img src={item.img} alt="" style={{ height: 215, objectFit: 'cover' }} />
      }
    >
      <MyCard.Meta
        title={
          <MyText color='#0A033C' size={16} weight={600} style={{ textOverflow: 'initial' }}>
            {item.label}
          </MyText>
        }
        description={
          <Flex align='center' gap={8} style={{ marginTop: 16 }}>
            {item.isLiked ? <HeartFilled style={{ fontSize: 16, color: '#FF2D55' }} /> :
              <HeartOutlined style={{ fontSize: 16 }} />}
            <MyText color='#68727D' size={16} weight={400}>
              {item.likeCount}
            </MyText>
          </Flex>
        }
      />
    </MyCard>
  );
});

export const Section5 = () => {
  const { lang } = useLang();

  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();
  const dispatch = useDispatch();
  const articleList = useSelector((state: any) => state.articles.articleList);

  const {t} = useTranslation("common")
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isTablet = screens.md && !screens.xl && !screens.xxl;

  useEffect(() => {
    dispatch(fetchArticleListAction({}));
  }, []);

  useEffect(() => {
    if (!articleList.success || !articleList.data) return;
    setArticles(articleList.data.list || []);
    setLoading(false);
  }, [articleList.success, articleList.data]);

  // useEffect(() => {
  //   const loadData = async () => {
  //     setLoading(true);
  //     try {
  //       const articleList = await fetchArticleList(undefined, undefined,undefined);
  //       setArticles(articleList.list);
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   loadData();
  // }, []);

  const handleAllArticlesClick = () => {
    embeddedNavigate(ROUTE_PATH.ARTICLES);
  };

  const getRandomLikes = (max: number) => {
    const array = new Uint32Array(1);
    crypto.getRandomValues(array);
    return array[0] % (max + 1);
  };

  const defaultData = [...new Array(5)].map((_, i) => ({
    img: 'https://i.pinimg.com/originals/5b/6e/ca/5b6eca63605bea0eeb48db43f77fa0ce.jpg',
    label: t("let'sPlay"),
    likeCount: getRandomLikes(15),
    isLiked: !!(i % 2),
    id: i,
  }));

  const formattedArticles = articles.map(article => ({
    img: article.image,
    label: article.header,
    like_count: article.like_count,
    is_liked_by_user: article.is_liked_by_user,
    id: article.id,
  }));

  const articlesToDisplay = articles.length > 0 ? formattedArticles : defaultData;

  return (
    <WaveContainer
      containerStyle={{
        backgroundColor: '#E7FAFF',
        paddingBottom: 50
      }}>
      <Row justify="center">
        <Col span={20}>
          <Row gutter={[48, 48]}>
            <Col span={24}>
              <Row align="middle" justify="space-between" style={screens.xs ? { display: 'flex', justifyContent: 'center' } : {}}>
                <Col>
                  <MyText color='#0A033C' weight={800} size={screens.xs ? 28 : isTablet ? 32 : 48} lineHeight={isTablet ? '34px' : '64px'} style={{ fontFamily: 'Nunito', textAlign: 'center' }}>
                    {t("popularArticles")}
                  </MyText>
                </Col>
                {!screens.xs && (
                <Col>
                  <MyButton type='primary' color='blue' onClick={handleAllArticlesClick}>
                    {t("allArticles")}
                  </MyButton>
                </Col>
                )}
              </Row>
            </Col>

            {/* <Col span={24}>
              <Row gutter={[16, 16]} justify="space-between">
                {articlesToDisplay.map((item, index) => (
                  <Col key={index} span={4} style={{ height: '100%' }}>
                    <Component item={item} onClick={() => navigate(`/articles/${item.id}`)} style={{ height: '100%' }}/>
                  </Col>
                ))}
              </Row>
            </Col> */}

            <Col span={24} style={screens.xs ? { height: '350px', marginBottom: '120px' } : {}}>
            <EmblaCarousel slides={articlesToDisplay} options={OPTIONS} />
          </Col>
          </Row>
        </Col>
        {screens.xs && (
      <Col span={24} style={screens.xs ? { display: 'flex', justifyContent: 'center' } : {}}>
                  <MyButton type='primary' color='blue' onClick={handleAllArticlesClick} style={screens.xs ? {height: '56px', fontSize: '22px' } : {}}>
                  {t("allArticles")}
                  </MyButton>
                </Col>
      )}
      </Row>
    </WaveContainer>
  );
}
